<template>
  <div>
    <Navbar />
    <b-overlay v-if="!Loading">
      <div
        class="container"
        style="min-height: calc(100vh - 335px); margin-top: 100px"
      >
        <b-row>
          <b-col class="text-left">
            <h2
              @click="$router.push({ name: 'FormGroup' })"
              style="cursor: pointer"
            >
              <b-icon-chevron-left></b-icon-chevron-left>
              {{ $t("FormGroup") }}
            </h2>
          </b-col>
        </b-row>

        <b-row class="mt-3 mb-3">
          <b-col sm="12" md="2">
            <custom-input
              v-model="FormGroup.docnumber"
              :placeholder="$t('docnumber')"
              :label="$t('docnumber')"
            ></custom-input>
          </b-col>
          <b-col sm="12" md="2">
            <custom-date-picker
              placeholder="00.00.0000"
              @keyup="BindValue"
              v-model="FormGroup.docdate"
              :label="$t('docdate')"
            ></custom-date-picker>
          </b-col>
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('year')"
              :content="FormGroup.docyear"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('oblast')"
              :content="FormGroup.oblastname"
            ></custom-label>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('region')"
              :content="FormGroup.regionname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="8" v-if="CoachAssignment.initiativtypeid == 3">
            <custom-label
              :label="$t('proftalim')"
              :content="FormGroup.organizationname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="8" v-if="CoachAssignment.initiativtypeid == 2">
            <custom-label
              :label="$t('school')"
              :content="FormGroup.organizationname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="8" v-if="CoachAssignment.initiativtypeid == 4">
            <custom-label
              :label="$t('oliytalim')"
              :content="FormGroup.organizationname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4" v-if="CoachAssignment.initiativtypeid == 1">
            <custom-label
              :label="$t('regionsector')"
              :content="FormGroup.regionsectorname"
            ></custom-label>
          </b-col>
          <b-col sm="12" md="4" v-if="CoachAssignment.initiativtypeid == 1">
            <custom-label
              :label="$t('mfy')"
              :content="FormGroup.mfyname"
            ></custom-label>
          </b-col>
        </b-row>
        <!-- v-if="isView" -->
        <b-row class="mt-3 mb-3">
          <b-col sm="12" md="8">
            <div class="d-flex">
              <div style="width: 100%">
                <custom-label
                  :label="$t('group')"
                  :content="FormGroup.detail"
                ></custom-label>
              </div>
              <div style="width: 10%">
                <b-button
                  block
                  :disabled="canchange"
                  @click="OpenCoachModal"
                  style="height: 100%"
                  variant="primary"
                  size="lg"
                >
                  <b-icon-three-dots-vertical></b-icon-three-dots-vertical
                ></b-button>
              </div>
            </div>
          </b-col>
          <b-col sm="12" md="4" v-if="!!FormGroup.genderid">
            <custom-label
              :label="$t('gender')"
              :content="FormGroup.gendername"
            ></custom-label>
            <!-- <custom-select
              :label="$t('gender')"
              :placeholder="$t('choose')"
              v-model="FormGroup.genderid"
              :options="GenderList"
              @input="changeGender"
              :disabled="canchange"
            ></custom-select> -->
            <!-- :disabled="canchange" -->
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('agecategory')"
              :content="FormGroup.agecategoryname"
            ></custom-label>
            <!-- <custom-select
              :label="$t('agecategory')"
              :placeholder="$t('choose')"
              v-model="FormGroup.agecategoryid"
              :disabled="canchange"
              :options="AgeCategoryList"
              @input="changeAgeCategory"
            ></custom-select> -->
          </b-col>
          <b-col sm="12" md="4" class="mb-3">
            <custom-label
              :label="$t('sporttypecategory')"
              :content="FormGroup.sporttypecategoryname"
            ></custom-label>
            <!-- <custom-select
              :label="$t('sporttypecategory')"
              :placeholder="$t('choose')"
              v-model="FormGroup.sporttypecategoryid"
              @input="changeSportTypeCategory"
              :options="SportTypeCategoryList"
            ></custom-select> -->
          </b-col>
          <b-col sm="12" md="4">
            <custom-label
              :label="$t('sporttype1')"
              :content="FormGroup.sporttypename"
            ></custom-label>
            <!-- <custom-select
              :label="$t('sporttype1')"
              :placeholder="$t('choose')"
              v-model="FormGroup.sporttypeid"
              :disabled="canchange"
              :options="SportTypeList"
              @input="ChangeSportType"
            ></custom-select> -->
          </b-col>
          <!-- <b-col sm="12" md="1" v-if="canchange">
            <b-button block @click="OpenGroupModal" variant="primary" size="lg">
              <p class="m-0 p-0 p-1">
                {{ $t("+") }}
              </p>
            </b-button>
          </b-col>-->
        </b-row>
        <b-row class="mt-2">
          <b-col sm="12" md="4" lg="4" class="text-right">
            <b-button
              block
              @click="OpenPersonModal"
              variant="primary"
              size="lg"
            >
              <p class="m-0 p-0 p-1">{{ $t("add") }}</p>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col sm="12" md="12">
            <b-table
              ref="refInvoiceListTable"
              :items="FormGroup.Tables"
              responsive
              :fields="fields"
              primary-key="id"
              sticky-header="65vh"
              no-border-collapse
              :busy="isBusy"
              show-empty
              :tbody-tr-class="rowClass"
              :empty-text="$t('NotFound')"
              class="position-relative"
            >
              <template v-slot:cell(actions)="{ item }">
                <div class="text-center">
                  <!-- <b-link>
                      <feather-icon
                        style="margin-right: 5px"
                        @click="EditTable(item)"
                        icon="EditIcon"
                      ></feather-icon>
                  </b-link>-->
                  <b-link>
                    <b-icon-trash
                      scale="1.3"
                      style="color: red"
                      @click="DeleteRow(item)"
                    ></b-icon-trash>
                  </b-link>
                </div>
              </template>
              <template v-slot:cell(statusname)="{ item }">
                <b-badge
                  style="cursor: pointer"
                  :variant="getColor(item)"
                  class="btn-soft-primary pr-btn"
                  size="sm"
                  >{{ item.statusname }}</b-badge
                >
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col class="text-right">
            <b-button variant="success" @click="SaveData">
              <b-spinner v-if="SaveLoading" small></b-spinner>
              {{ $t("save") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-modal
        :ok-title="$t('add')"
        cancel-variant="danger"
        v-model="CoachAssignmentModal"
        size="xl"
        ok-variant="success"
        @ok="AddCoachData(coachvalue)"
      >
        <template #modal-title>
          {{ $t("CoachAssignment") }}
          <b-spinner v-if="CoachAssignmentLoading" small></b-spinner>
        </template>
        <b-card-text>
          <coach-assignment-list
            @DblClick="AddCoachData"
            @SelectedItem="SelectedCoachItem"
            :coachassignmentid="CoachAssignment.id"
          ></coach-assignment-list>
        </b-card-text>
      </b-modal>
      <b-modal
        v-model="PersonModal"
        :cancel-title="$t('cancel')"
        :ok-title="$t('add')"
        cancel-variant="danger"
        size="xl"
        ok-variant="success"
        @ok="AddPerson()"
      >
        <template #modal-title>
          {{ $t("Person") }}
          <b-spinner v-if="PersonLoading" small></b-spinner>
        </template>
        <b-card-text>
          <p style="color: red; font-size: 18px" class="text-right">
            <span>
              {{ $t("athletecountgroup") }} :
              {{ GroupNameData.athletecount }}
            </span>
          </p>
          <b-table
            ref="refInvoiceListTable"
            :items="items"
            responsive
            :fields="fields1"
            primary-key="id"
            sticky-header="65vh"
            no-border-collapse
            :busy="isBusy"
            selectable
            :select-mode="selectMode"
            @row-selected="onRowSelected"
            show-empty
            :empty-text="$t('NotFound')"
            class="position-relative"
            @sort-changed="SortChange"
          >
            <template v-slot:cell(statusname)="{ item }">
              <b-badge
                style="cursor: pointer"
                :variant="getColor(item)"
                class="btn-soft-primary pr-btn"
                size="sm"
                >{{ item.statusname }}</b-badge
              >
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true">&check;</span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">&nbsp;</span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>
          </b-table>
        </b-card-text>
      </b-modal>
      <b-modal
        v-model="GroupModal"
        :cancel-title="$t('cancel')"
        :ok-title="$t('add')"
        cancel-variant="danger"
        size="xl"
        ok-variant="success"
        @ok="AddGroup()"
      >
        <template #modal-title>
          {{ $t("CoachAssignment") }}
          <b-spinner v-if="PersonLoading" small></b-spinner>
        </template>
        <b-card-text>
          <b-table
            ref="refInvoiceListTable"
            :items="items2"
            responsive
            :fields="fields2"
            primary-key="id"
            sticky-header="65vh"
            no-border-collapse
            :busy="isBusy"
            show-empty
            selectable
            :select-mode="selectMode1"
            @row-selected="onRowSelected1"
            :empty-text="$t('NotFound')"
            class="position-relative"
            @sort-changed="SortChange"
          >
            <template v-slot:cell(statusname)="{ item }">
              <b-badge
                style="cursor: pointer"
                :variant="getColor(item)"
                class="btn-soft-primary pr-btn"
                size="sm"
                >{{ item.statusname }}</b-badge
              >
            </template>
            <template v-slot:cell(index)="{ index }">
              <span class="text-center">{{ index + 1 }}</span>
            </template>
          </b-table>
        </b-card-text>
      </b-modal>
    </b-overlay>
    <div
      v-if="Loading"
      style="width: 100%; height: calc(100vh - 335px)"
      class="d-flex align-items-center justify-content-center"
    >
      <b-spinner></b-spinner>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";
import {
  BIconPlus,
  BIconPaperclip,
  BIconTrash,
  BIconCheck2Circle,
  BIconChevronLeft,
  BIconX,
  BIconExclamationTriangleFill,
  BIconCheckCircleFill,
  BIconSearch,
  BListGroup,
  BOverlay,
  BIconThreeDotsVertical,
} from "bootstrap-vue";
import CustomSelect from "./components/CustomSelect.vue";
import CustomInput from "./components/CustomInput.vue";
import CustomDatePicker from "./components/CustomDatepicker.vue";
import CustomLabel from "./components/CustomLabel.vue";
import RegistrationOfAthleteService from "../services/registrationofathlete.service";
import CoachAssignmentService from "../services/coachassignment.service";
import HelperService from "../services/helper.service";
import OblastService from "../services/oblast.service";
import SportTypeService from "../services/sporttype.service";
import SportTypeCategoryService from "../services/sporttypecategory.service";
import FormGroupService from "../services/formgroup.service";
import AgeCategoryService from "../services/agecategory.service";
import CoachAssignmentList from "././components/Sport/CoachAssignmentList.vue";
export default {
  components: {
    Navbar,
    BIconPlus,
    BIconSearch,
    BOverlay,
    CustomSelect,
    CustomInput,
    CustomDatePicker,
    CustomLabel,
    BIconPaperclip,
    BIconTrash,
    Footer,
    BIconCheck2Circle,
    BIconChevronLeft,
    BListGroup,
    BIconX,
    BIconExclamationTriangleFill,
    BIconCheckCircleFill,
    CoachAssignmentList,
    BIconThreeDotsVertical,
  },
  data() {
    return {
      FormGroup: {},
      coachvalue: {},
      OblastList: [],
      RegionList: [],
      CoachAssignment: {},
      PersonModal: false,
      CoachAssignmentModal: false,
      CoachAssignmentLoading: false,
      isdisabled: false,
      GroupModal: false,
      isBusy: false,
      MfyList: [],
      items: [],
      RegionSectorList: [],
      GenderList: [],
      canchange: false,
      AgeCategoryList: [],
      isView: false,
      selectMode: "multi",
      selectMode1: "single",
      selected: [],
      GroupNameData: {
        SportTypeName: "",
        AgeCategoryName: "",
        SportTypeCategoryName: "",
        GenderName: "",
        athletecount: 0,
        translatecount: 0,
      },
      IdentityDocumentList: [],
      filter: {
        oblastid: 0,
        regionid: 0,
        regionsectorid: 0,
        mfyid: 0,
        Search: "",
        Sort: "",
        Order: "asc",
        perPage: 400,
        currentPage: 1,
        perPageOptions: [10, 20, 50, 100],
        totalRows: 0,
      },
      filterList: {
        coachassignmentid: 0,
        Search: "",
        SortColumn: "",
        OrderType: "asc",
        PageNumber: 1,
        PageLimit: 20,
      },
      items2: [],
      editedIndex1: -1,
      lang: localStorage.getItem("locale") || "uz_latn",
      DocumentSeriesList: [],
      SearchLoading: false,
      PersonLoading: false,
      SaveLoading: false,
      lang: localStorage.getItem("locale"),
      Loading: false,
      SportTypeList: [],
      SportTypeCategoryList: [],
      selected1: [],
      fields1: [
        {
          key: "selected",
          label: this.$t(""),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "fullname",
          label: this.$t("FIO"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "documentseries",
          label: this.$t("documentseries"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
        {
          key: "documentnumber",
          label: this.$t("documentnumber"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
        {
          key: "dateofbirth",
          label: this.$t("dateofbirth"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
        {
          key: "gendername",
          label: this.$t("gender"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ],
      fields2: [
        {
          key: "index",
          label: this.$t("index"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "gendername",
          label: this.$t("gender"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "agecategoryname",
          label: this.$t("agecategory"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "sporttypename",
          label: this.$t("sporttype1"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "groupname",
          label: this.$t("group"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
      ],
      fields: [
        {
          key: "fullname",
          label: this.$t("FIO"),
          thClass: "text-center",
          tdClass: "text-left",
          sortable: false,
        },
        {
          key: "documentseries",
          label: this.$t("documentseries"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
        {
          key: "documentnumber",
          label: this.$t("documentnumber"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
        {
          key: "dateofbirth",
          label: this.$t("dateofbirth"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },

        {
          key: "gendername",
          label: this.$t("gender"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },

        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.currentPage - 1) * this.filter.perPage + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.perPage) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.currentPage * this.filter.perPage >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.currentPage * this.filter.perPage;
        }
      }
    },
  },
  created() {
    this.Loading = true;
    OblastService.GetAll(this.lang).then((res) => {
      this.OblastList = res.data;
    });
    HelperService.GetGenderList(this.lang).then((res) => {
      this.GenderList = res.data;
    });
    //  SportTypeCategoryService.GetAll(this.lang).then((res) => {
    //   this.SportTypeCategoryList = res.data;
    // });
    FormGroupService.Get(
      this.$route.params.id,
      JSON.parse(localStorage.getItem("user_info")).MobileNumber
    )
      .then((res) => {
        this.FormGroup = res.data;
        CoachAssignmentService.Get(
          0,
          JSON.parse(localStorage.getItem("user_info")).MobileNumber,
          this.lang
        ).then((res) => {
          this.CoachAssignment = res.data;
        });
        if (!!this.FormGroup.gendername) {
          this.isView = true;
        }
        if (this.$route.params.id != 0) {
          this.calculate();
          this.SportType();
          AgeCategoryService.GetAll(this.lang, this.FormGroup.genderid)
            .then((res1) => {
              this.AgeCategoryList = res1.data;
            })
            .catch((error) => {
              this.makeToast(error.response.data.error, "error");
            });
        }
        this.Loading = false;
      })
      .catch((error) => {
        this.makeToast(error.response.data.error, "error");
      });
  },
  methods: {
    changeGender() {
      if (!!this.FormGroup.genderid) {
        this.GroupNameData.GenderName = this.GenderList.filter(
          (item) => this.FormGroup.genderid === item.id
        )[0].name;
        AgeCategoryService.GetAll(this.lang, this.FormGroup.genderid)
          .then((res1) => {
            this.AgeCategoryList = res1.data;
          })
          .catch((error) => {
            this.makeToast(error.response.data.error, "error");
          });
      }
      this.FormGroup.agecategoryid = 0;
      this.FormGroup.sporttypecategoryid = 0;
      (this.FormGroup.sporttypeid = 0), (this.FormGroup.detail = "");
    },
    changeSportTypeCategory() {
      if (!!this.FormGroup.sporttypecategoryid) {
        this.FormGroup.SportTypeCategoryName =
          this.SportTypeCategoryList.filter(
            (item) => this.FormGroup.sporttypecategoryid === item.id
          )[0].name;
      }
      this.FormGroup.sporttypeid = 0;
      this.FormGroup.detail = "";
      this.SportType();
    },

    changeAgeCategory() {
      if (!!this.FormGroup.agecategoryid) {
        this.FormGroup.AgeCategoryName = this.AgeCategoryList.filter(
          (item) => this.FormGroup.agecategoryid === item.id
        )[0].name;
        SportTypeCategoryService.GetAll(this.lang, this.FormGroup.agecategoryid)
          .then((res1) => {
            this.SportTypeCategoryList = res1.data;
          })
          .catch((error) => {
            this.makeToast(error.response.data.error, "error");
          });
      }
      // this.FormGroup.agecategoryid = 0;
      this.FormGroup.sporttypecategoryid = 0;
      (this.FormGroup.sporttypeid = 0), (this.FormGroup.detail = "");
    },
    ChangeSportType() {
      this.FormGroup.detail = "";
      this.FormGroup.coachassignmenttableid = 0;
      CoachAssignmentService.GetCoachAssignmentTableByPerson(
        this.FormGroup.genderid,
        this.FormGroup.agecategoryid,
        this.FormGroup.sporttypeid
      )
        .then((res) => {
          this.items2 = res.data;
          this.FormGroup.detail = res.data.groupname;
          this.FormGroup.coachassignmenttableid = res.data.id;
          this.changeSportType();
        })
        .catch((error) => {
          this.makeToast(error.response.data.error, "error");
          this.Loading = false;
        });
    },

    calculate() {
      var self = this;
      var index = 0;
      self.FormGroup.Tables.forEach(function (item) {
        if (item.Status !== 3) {
          index++;
        }
      });
      if (index > 0) self.canchange = true;
      else self.canchange = false;
    },

    rowClass(item, type) {
      if (item.Status === 3 && !!item.Status) {
        return "d-none";
      }
    },
    onRowSelected(items) {
      this.selected = items;
      // if (this.GroupNameData.athletecount != 0) {
      //   this.GroupNameData.athletecount =
      //     this.GroupNameData.athletecount - this.selected.length;
      // }
      // if(this.selected.length > this.GroupNameData.athletecount){
      //           this.selected.length = 0
      // }
    },
    onRowSelected1(items) {
      this.selected1 = items;
      // if(this.selected.length > this.GroupNameData.athletecount){
      //           this.selected.length = 0
      // }
    },
    // EditTable(item) {
    //   if (item.Status == 0) {
    //     item.Status = 2;
    //   }
    //   this.editedIndex1 = this.AgeCategory.Tables.indexOf(item);
    //   this.tabrow = Object.assign({}, item);
    // },
    DeleteRow(item) {
      item.Status = 3;
      this.calculate();
    },

    changeSportType() {
      this.GroupNameData.athletecount = this.SportTypeList.filter(
        (item) => this.FormGroup.sporttypeid === item.id
      )[0].participantcount;
      this.GroupNameData.translatecount = this.GroupNameData.athletecount;
    },
    OpenCoachModal() {
      this.CoachAssignmentModal = true;
    },
    OpenPersonModal() {
      if (!this.check()) {
        return false;
      }
      this.isBusy = true;
      RegistrationOfAthleteService.GetList(
        this.filter.Search,
        this.filter.Sort,
        this.filter.Order,
        this.filter.currentPage,
        this.filter.perPage,
        this.FormGroup.oblastid,
        this.FormGroup.regionid,
        this.FormGroup.regionsectorid,
        this.FormGroup.genderid,
        this.FormGroup.sporttypeid,
        this.FormGroup.sporttypecategoryid,
        this.FormGroup.agecategoryid,
        this.FormGroup.docyear,
        0,
        this.lang,
        2 //Status faqat tastiqlanganlari chiqishi kerak ekan
      ).then((res) => {
        this.items = res.data.rows;
        this.filter.totalRows = res.data.total;
        this.isBusy = false;
      });
      this.PersonModal = true;
    },
    OpenGroupModal() {
      CoachAssignmentService.Get(
        0,
        JSON.parse(localStorage.getItem("user_info")).MobileNumber,
        this.lang
      ).then((res) => {
        this.CoachAssignment = res.data;
        this.filterList.coachassignmentid = res.data.youthleaderpersonid;
        CoachAssignmentService.GetCoachAssignmentTableByPerson(
          this.filterList.coachassignmentid
        )
          .then((res) => {
            this.items2 = res.data;
          })
          .catch((error) => {
            this.makeToast(error.response.data.error, "error");
            this.Loading = false;
          });
      });
      this.GroupModal = true;
    },
    SelectedCoachItem(data) {
      this.coachvalue = data;
    },
    AddCoachData(data) {
      var self = this;
      console.log(data);
      self.FormGroup.detail = data.groupname;
      self.FormGroup.agecategoryid = data.agecategoryid;
      self.FormGroup.agecategoryname = data.agecategoryname;
      self.FormGroup.sporttypecategoryid = data.sporttypecategoryid;
      self.FormGroup.sporttypecategoryname = data.sporttypecategoryname;
      self.FormGroup.sporttypeid = data.sporttypeid;
      self.FormGroup.sporttypename = data.sporttypename;
      self.FormGroup.genderid = data.genderid;
      self.FormGroup.gendername = data.gendername;
      this.SportType();
      self.CoachAssignmentModal = false;
    },
    SortChange(data) {
      this.filter.Sort = data.sortBy;
      this.filter.Order = data.sortDesc ? "desc" : "asc";
    },
    changeCategory() {
      this.GroupNameData.AgeCategoryName = this.AgeCategoryList.filter(
        (item) => this.FormGroup.agecategoryid === item.id
      )[0].name;
      this.FormGroup.sporttypeid = 0;
      this.FormGroup.detail = "";
      this.SportType();
    },
    // SportType() {
    //   SportTypeService.GetAll(
    //     this.lang,
    //     "",
    //     this.FormGroup.genderid,
    //     this.FormGroup.agecategoryid
    //   ).then(res => {
    //     this.SportTypeList = res.data;
    //     this.changeSportType();
    //   });
    // },
    SportType() {
      SportTypeService.GetAll(
        this.lang,
        null,
        this.FormGroup.genderid,
        this.FormGroup.agecategoryid,
        this.FormGroup.sporttypecategoryid,
        true, 
        this.CoachAssignment.initiativtypeid

      ).then((res) => {
        this.SportTypeList = res.data;
        this.changeSportType();
      });
    },

    AddPerson() {
      var dublicate = false;
      for (let i = 0; i < this.FormGroup.Tables.length; i++) {
        var item = this.FormGroup.Tables[i];
        if (
          this.selected.map((el) => el.fullname).includes(item.fullname) &&
          item.Status != 3
        ) {
          dublicate = true;
        }
      }
      if (dublicate) {
        this.makeToast(this.$t("Dublicate"), "error");
        return false;
      }

      // this.FormGroup.Tables.forEach(function (item) {
      //   console.log(this.selected)
      //   this.selected.forEach(function (el) {
      //     if (item.Status !== 3 && item.fullname === el.fullname) {
      //       dublicate = true;
      //     }
      //   });
      // });
      // if (dublicate) {
      //   this.makeToast(
      //     this.$t("Dublicate"),
      //     "error"
      //   );
      //   return false;
      // }
      for (let i = 0; i < this.selected.length; i++) {
        this.FormGroup.Tables.push({
          gendername: this.selected[i].gendername,
          sporttypename: this.selected[i].sporttypename,
          dateofbirth: this.selected[i].dateofbirth,
          documentseries: this.selected[i].documentseries,
          documentnumber: this.selected[i].documentnumber,
          dateofissue: this.selected[i].dateofissue,
          fullname: this.selected[i].fullname,
          registrationofathleteid: this.selected[i].id,
          id: 0,
          ownerid: 0,
          Status: 1,
        });
      }
      this.calculate();
    },
    AddGroup() {
      this.FormGroup.detail = this.selected1[0].groupname;
      this.FormGroup.sporttypename = this.selected1[0].sporttypename;
      this.FormGroup.agecategoryname = this.selected1[0].agecategoryname;
      this.FormGroup.gendername = this.selected1[0].gendername;
      this.FormGroup.sporttypeid = this.selected1[0].sporttypeid;
      this.FormGroup.agecategoryid = this.selected1[0].agecategoryid;
      this.FormGroup.genderid = this.selected1[0].genderid;
      this.isView = true;
      this.SportType();
    },
    getColor(item) {
      if (item.statusname === "Создан") {
        return "primary";
      } else if (item.statusname === "Изменен") {
        return "info";
      } else if (item.statusname === "Не принято") {
        return "danger";
      } else if (item.statusname === "Отменено") {
        return "danger";
      } else if (item.statusname === "Утвержден") {
        return "success";
      } else if (item.statusname === "Отправлен") {
        return "warning";
      } else {
        return "primary";
      }
    },
    makeToast(message, type) {
      this.$toast.open({
        message: message,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
    check() {
      if (
        this.FormGroup.docnumber === 0 ||
        this.FormGroup.docnumber === null ||
        this.FormGroup.docnumber === undefined ||
        this.FormGroup.docnumber === ""
      ) {
        this.makeToast(this.$t("docnumberNotSelected"), "error");
        return false;
      }
      if (
        this.FormGroup.docdate === 0 ||
        this.FormGroup.docdate === null ||
        this.FormGroup.docdate === undefined ||
        this.FormGroup.docdate === ""
      ) {
        this.makeToast(this.$t("docdateNotCorrect"), "error");
        return false;
      }
      if (
        this.FormGroup.oblastid === 0 ||
        this.FormGroup.oblastid === null ||
        this.FormGroup.oblastid === undefined ||
        this.FormGroup.oblastid === ""
      ) {
        this.makeToast(this.$t("NotSelectoblastid"), "error");
        return false;
      }
      if (
        this.FormGroup.regionid === 0 ||
        this.FormGroup.regionid === null ||
        this.FormGroup.regionid === undefined ||
        this.FormGroup.regionid === ""
      ) {
        this.makeToast(this.$t("NotSelectregionid"), "error");
        return false;
      }
      if (this.CoachAssignment.initiativtypeid == 1) {
        if (
          this.FormGroup.mfyid === 0 ||
          this.FormGroup.mfyid === null ||
          this.FormGroup.mfyid === undefined ||
          this.FormGroup.mfyid === ""
        ) {
          this.makeToast(this.$t("mfyNotSelected"), "error");
          return false;
        }
        if (
          this.FormGroup.regionsectorid === 0 ||
          this.FormGroup.regionsectorid === null ||
          this.FormGroup.regionsectorid === undefined ||
          this.FormGroup.regionsectorid === ""
        ) {
          this.makeToast(this.$t("regionsectorNotSelected"), "error");
          return false;
        }
      }
      // if (
      //   this.FormGroup.genderid === 0 ||
      //   this.FormGroup.genderid === null ||
      //   this.FormGroup.genderid === undefined ||
      //   this.FormGroup.genderid === ""
      // ) {
      //   this.makeToast(this.$t("genderidNotCorrect"), "error");
      //   return false;
      // }
      if (
        this.FormGroup.agecategoryid === 0 ||
        this.FormGroup.agecategoryid === null ||
        this.FormGroup.agecategoryid === undefined ||
        this.FormGroup.agecategoryid === ""
      ) {
        this.makeToast(this.$t("agecategoryNotSelected"), "error");
        return false;
      }
      if (
        this.FormGroup.sporttypeid === 0 ||
        this.FormGroup.sporttypeid === null ||
        this.FormGroup.sporttypeid === undefined ||
        this.FormGroup.sporttypeid === ""
      ) {
        this.makeToast(this.$t("sporttypeNotSelected"), "error");
        return false;
      }
      if (
        this.FormGroup.detail === 0 ||
        this.FormGroup.detail === null ||
        this.FormGroup.detail === undefined ||
        this.FormGroup.detail === ""
      ) {
        this.makeToast(this.$t("detailNotCorrect"), "error");
        return false;
      }
      // if (
      //   this.FormGroup.Tables.filter((item) => item.Status != 3).length != this.GroupNameData.translatecount
      // ) {
      //   this.makeToast(
      //     this.$t("athletelengthnotcorrect"),
      //     this.$t("Error"),
      //     "danger"
      //   );
      //   return false;
      // }
      return true;
    },
    check1() {
      if (
        this.FormGroup.docnumber === 0 ||
        this.FormGroup.docnumber === null ||
        this.FormGroup.docnumber === undefined ||
        this.FormGroup.docnumber === ""
      ) {
        this.makeToast(this.$t("docnumberNotSelected"), "error");
        return false;
      }
      if (
        this.FormGroup.docdate === 0 ||
        this.FormGroup.docdate === null ||
        this.FormGroup.docdate === undefined ||
        this.FormGroup.docdate === ""
      ) {
        this.makeToast(this.$t("docdateNotCorrect"), "error");
        return false;
      }
      if (
        this.FormGroup.oblastid === 0 ||
        this.FormGroup.oblastid === null ||
        this.FormGroup.oblastid === undefined ||
        this.FormGroup.oblastid === ""
      ) {
        this.makeToast(this.$t("oblastNotSelected"), "error");
        return false;
      }
      if (
        this.FormGroup.regionid === 0 ||
        this.FormGroup.regionid === null ||
        this.FormGroup.regionid === undefined ||
        this.FormGroup.regionid === ""
      ) {
        this.makeToast(this.$t("regionNotSelected"), "error");
        return false;
      }
      if (this.CoachAssignment.initiativtypeid == 1) {
        if (
          this.FormGroup.mfyid === 0 ||
          this.FormGroup.mfyid === null ||
          this.FormGroup.mfyid === undefined ||
          this.FormGroup.mfyid === ""
        ) {
          this.makeToast(this.$t("mfyNotSelected"), "error");
          return false;
        }
        if (
          this.FormGroup.regionsectorid === 0 ||
          this.FormGroup.regionsectorid === null ||
          this.FormGroup.regionsectorid === undefined ||
          this.FormGroup.regionsectorid === ""
        ) {
          this.makeToast(this.$t("regionsectorNotSelected"), "error");
          return false;
        }
      }
      if (
        this.FormGroup.Tables.filter((item) => item.Status != 3).length >
        this.GroupNameData.translatecount
      ) {
        this.makeToast(
          this.$t("athletecountNotCorrect", {
            athletecount: this.GroupNameData.translatecount,
            selected: this.FormGroup.Tables.filter((item) => item.Status != 3)
              .length,
          }),
          "error"
        );
        return false;
      }
      // if (
      //   this.FormGroup.genderid === 0 ||
      //   this.FormGroup.genderid === null ||
      //   this.FormGroup.genderid === undefined ||
      //   this.FormGroup.genderid === ""
      // ) {
      //   this.makeToast(this.$t("genderNotSelected"), "error");
      //   return false;
      // }
      // if (
      //   this.FormGroup.agecategoryid === 0 ||
      //   this.FormGroup.agecategoryid === null ||
      //   this.FormGroup.agecategoryid === undefined ||
      //   this.FormGroup.agecategoryid === ""
      // ) {
      //   this.makeToast(this.$t("agecategoryNotSelected"), "error");
      //   return false;
      // }
      // if (
      //   this.FormGroup.sporttypeid === 0 ||
      //   this.FormGroup.sporttypeid === null ||
      //   this.FormGroup.sporttypeid === undefined ||
      //   this.FormGroup.sporttypeid === ""
      // ) {
      //   this.makeToast(this.$t("sporttypeNotSelected"), "error");
      //   return false;
      // }
      // if (
      //   this.FormGroup.detail === 0 ||
      //   this.FormGroup.detail === null ||
      //   this.FormGroup.detail === undefined ||
      //   this.FormGroup.detail === ""
      // ) {
      //   this.makeToast(this.$t("detailNotCorrect"), "error");
      //   return false;
      // }
      if (this.FormGroup.Tables.length === 0) {
        this.makeToast(this.$t("TablesNotFilled"), "error");
        return false;
      }
      return true;
    },
    BindValue(data) {
      this.filter.dateofbirth = data;
    },
    SaveData() {
      //   if (this.AdoptionPermission.KadastrData === null) {
      //     this.makeToast(this.$t("NotKadastrInfo"), "error");
      //     return false;
      if (!this.check1()) {
        return false;
      }
      this.SaveLoading = true;
      FormGroupService.Update(this.FormGroup)
        .then((res) => {
          this.SaveLoading = false;
          this.$router.push({ name: "FormGroup" });
        })
        .catch((error) => {
          this.SaveLoading = false;
          this.makeToast(error.response.data.error, "error");
        });
    },
  },
};
</script>

<style lang="scss">
.application-modal {
  .modal-xl {
    min-width: 1300px !important;
  }
}
</style>
